import React from "react";
import { observer, inject } from "mobx-react";
import { observable, } from 'mobx';
import { withRouter } from "react-router-dom";
import { ToolbarDropdown, ToolbarSection } from "@components/Toolbar/ToolbarDropdown"
import PurchaseOrderSettings from "./PurchaseOrderSettings";



@inject("store")
@observer
class PurchaseOrderThankYou extends React.Component {
	@observable processingCheckout = false;

	constructor(props) {
		super(props);
		
	}

	thankYouMessage() {
		const { orderNumber } = this.props;

		if (!orderNumber) return "En bekräftelse skickas till din mejl.";
		else return `En bekräftelse skickas till din mejl. Ditt ordernummer är ${orderNumber}!`;
	}

	
	render() {
		const { store } = this.props;
		const orderStore = store.order;

		const headerClasses = [
			"purchaseorder-header",
			"checkout",
			this.headerExpanded ? "expanded" : null
		];

		const footerClasses = [
			"purchaseorder-footer",
			"checkout",
			this.footerExpanded ? "expanded" : null
		];

		const parentMatch = this.props.match;



		return (
			<ToolbarDropdown key={"order-thankyou"} match={parentMatch}  {...this.props}>


				<ToolbarSection>
					<div className="h-100 mt-0 d-flex flex-column">
						<div className="card-body text-center align-self-stretch align-content-center flex-grow-1">
							<h1>Tack för din beställning!</h1>
							<p className="mb-0 mt-2" style={{ fontSize: "1.4rem" }}>
								{this.thankYouMessage()}
							</p>
							<p style={{ fontSize: "4rem" }}>🥳</p>
						</div>

						<hr />

						<div className="card-body align-self-end flex-grow-0 pt-0">
							<PurchaseOrderSettings />
						</div>

					</div>
				</ToolbarSection>

			</ToolbarDropdown>
		);
	}
}



export default withRouter(PurchaseOrderThankYou);